import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const NotificationsPage = lazy(() => import('@pages/notifications/NotificationsPage'));

// Route Components
const NotificationsList = () => {
  const { t } = useTranslation();

  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('notifications-page-title')}>
        <NotificationsPage />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default {
  NotificationsList,
};
